import React from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loading } from './';
import { sessionActions } from '../../state/modules/session';
import { compose, lifecycle } from 'recompose';
import queryString from 'query-string';

/**
 * Responsible of rendering logout loading redirecting the user after a successful logout
 */

const LoggedOut = () => (
  <Loading />
);

const mapStateToProps = (state) => ({
  auth0Config: state.configuration.auth0Config
});
const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
  login: bindActionCreators(sessionActions.session.login, dispatch),
  clearSession: bindActionCreators(sessionActions.session.clearSession, dispatch)
});

function performLogin(props) {
  const {
    clearSession,
    login,
    location,
    auth0Config
  } = props;

  if (auth0Config) {
    clearSession()
    const invitationToken = queryString.parse(location.search).invitationToken;

    login(invitationToken, '')
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      performLogin(this.props);
    },
    componentWillReceiveProps(nextProps) {
      performLogin(nextProps)
    }
  }),
)(LoggedOut);


// WEBPACK FOOTER //
// ./src/containers/pages/logged-out.js